import Pararax from './pararax';
import ScrollAnimation from './scrollanimation';
import Contents from './contents';

export default class smoothScrollManager {
    constructor(manager) {

        //manager
        this.manager = manager;

        this.pararax = new Pararax();
        this.animation = Useragnt.ie ? false : new ScrollAnimation();
        this.contents = new Contents(manager);

        this.w = window.innerWidth;
        this.h = window.innerHeight;

        this.$bodyTag;
        this.$root;
        this.$container;
        this.$body;
        this.$scrollIcon;

        this.inc = 0;
        this.nowInc = 0;
        this.prevInc = 0;
        this.dir = "next";
        this.add = 0.1;
        this.skew = 200;
        this.bodyHeight = 0;

        this.timer = [];

        this.type = "normal";

        this.inertia = Useragnt.mobile || (this.manager.isIpad && this.manager.portrait) ? false : true; /* 慣性スクロールを有効にするか */


        /* 状態監視用のフラグ */
        this.status = {
            comp     : false, /* 慣性スクロールが完了したか */
            pagetop: false, // ページトップ移動か
            deviceSize : "",
            parsent : 0,//何割進んだか
            progress : 1, // スクロール毎に終着点までの進捗を監視
            mode : "normal",//[ normal:ボディをスクロール制御 // select:指定したidをスクロール制御 ]
            temp : {//前回の状態保存。modeを切り替える際に使用する
                inc : 0,
                nowInc:0,
                prevInc:0,
                dir : "",
                flg : false
            },
            tempSub : {//二重で使用する場合に使用。前回の状態保存。modeを切り替える際に使用する
                inc : 0,
                nowInc:0,
                prevInc:0,
                dir : "",
                flg : false,
                use : false
            },
            scrollTo : false,
            exResizeMode:false,//その他のjsでリサイズ処理をさせる場合
            exResizeModeDelay : false,//exresizeモードから戻す際に遅延処理が必要な場合使用
            endPoint : false,//一番下まで移動したか

            scrollIcon:'show'

        }
        this.timer = {
            expressMode :""
        }

    }
    init(){

        this.$bodyTag = document.getElementsByTagName('body');
        this.$root = document.getElementById("l-root");
        this.$container = document.getElementById("l-scroll");
        this.$body = (this.manager.status.pageID == 'top') ? document.getElementById("p-kv") : document.getElementById("l-scroll-body");
        this.$headerNavi = document.getElementById("l-header__navi");
        this.$scrollIcon = document.getElementById("c-scroll__inner");

        this.status = {
            comp     : false, /* 慣性スクロールが完了したか */
            pagetop: false, // ページトップ移動か
            deviceSize : "",
            parsent : 0,//何割進んだか
            progress : 1, // スクロール毎に終着点までの進捗を監視
            mode : "normal",//[ normal:ボディをスクロール制御 // select:指定したidをスクロール制御 ]
            temp : {//前回の状態保存。modeを切り替える際に使用する
                inc : 0,
                nowInc:0,
                prevInc:0,
                dir : "",
                flg : false
            },
            tempSub : {//二重で使用する場合に使用。前回の状態保存。modeを切り替える際に使用する
                inc : 0,
                nowInc:0,
                prevInc:0,
                dir : "",
                flg : false,
                use : false
            },
            scrollTo : false,
            exResizeMode:false,//その他のjsでリサイズ処理をさせる場合
            exResizeModeDelay : false,//exresizeモードから戻す際に遅延処理が必要な場合使用
            endPoint : false,//一番下まで移動したか

            scrollIcon: 'show'

        }


        this.inc = 0;
        this.nowInc = 0;
        this.prevInc = 0;
        this.dir = "next";
        this.add = 0.05;
        this.skew = document.getElementById("p-photo")?200:50;

        if(!this.inertia) this.$bodyTag[0].classList.add('is-inertia-none');

        this.pararax.init(this);
        this.contents.init(this);

        this.toFast(0);


    }
    changeMode(select,$body){


        if(select==="normal"){
            this.$body = document.getElementById("l-scroll-body");

        }else{
            this.$body = $body;
        }

        if(select==="normal"){
            this.inc = this.status.temp.inc;
            this.nowInc = this.status.temp.nowInc;
            this.prevInc = this.status.temp.prevInc;
            this.skew = document.getElementById("p-photo")?200:50;
            this.resize(window.innerWidth,window.innerHeight,this.manager.mouse);
            this.status.mode = select;
            this.add = 0.05;
            this.toFast(this.inc);
            this.dir = this.status.temp.dir;

            this.status.temp.flg = false;

        }else{
            this.status.mode = select;

            this.status.temp.inc = this.inc;
            this.status.temp.nowInc = this.nowInc;
            this.status.temp.prevInc = this.prevInc;
            this.status.temp.dir = this.inc==0?"prev":this.dir;

            this.status.temp.flg = true;

            this.skew = 20;
            if($body){
                this.resize(window.innerWidth,window.innerHeight);
                this.reset(setInc,"modechange");
            }
        }

    }
    to(inc){

        TweenMax.killTweensOf(window,{scrollTo:true});
        TweenLite.to(window, 0.6, {ease: Power0.easeNone,scrollTo:{y:inc,autoKill:false},onComplete:()=>{
            this.status.scrollTo = false;
        }});
    }
    toFast(inc){

        window.scrollTo(0,0);
        this.status.scrollTo = false;
    }
    reset(inc,mode){
        this.update(0,"prev");

        this.nowInc = 0;
        this.add = 1; // 一瞬イージングなし
        this.trans();
        this.add = 0.05; // イージング戻す

    }
    wheel(dir){

        this.status.comp = false;

    }
    update(inc,dir){ /* スクロール方向を決めうちしないならdirは空で渡してください */

        this.inc = inc;

        this.dir = this.status.temp.flg?"next":!dir ? this.inc>this.prevInc?"next":"prev":dir;

        this.mode = "scroll";
        if(this.status.comp){
            this.$bodyTag[0].classList.add("is-scrolling");
        }

        this.status.comp = false;

        setTimeout(this.timer.expressMode);

    }
    move(fpsRate) {

        if(this.inc==undefined) return;

        this.nowInc +=  this.add * (this.inc - this.nowInc)*fpsRate;
        this.status.progress = Math.abs(this.nowInc/this.inc);
        this.trans();

    }
    trans() {

        if(this.inertia && this.manager.status.pageID != 'top'){
            this.$body.style.transform = 'translateY(-'+ this.nowInc +'px)'
        }

        if(this.nowInc > 50 && this.manager.status.pageID != 'top'){
            this.displaySwitching('hide');
        } else {
            this.displaySwitching('show');
        }

        if(this.pararax) this.pararax.mot(this.nowInc,this.status.progress);
        this.contents.update(this.inc,this.dir);

        /* スクロール連動で動作 */

        if(
        this.prevInc>this.nowInc-0.1&&this.dir=="next" ||
        this.prevInc<this.nowInc+0.1&&this.dir=="prev"
        ){
            this.onComplete();
        }
        this.prevInc = this.nowInc;
    }

    displaySwitching(type){
        if(type == 'hide'){
            if(this.status.scrollIcon == 'hide') return;
            this.status.scrollIcon = 'hide';
            TweenMax.to(this.$scrollIcon, .6 ,{
                opacity:0,
                y: -50,
                display: 'none',
                ease: Power2.easeOut,
            });
            TweenMax.to(this.$headerNavi, .6 ,{
                opacity:0,
                ease: Power2.easeOut,
            });
        }else{
            if(this.status.scrollIcon == 'show') return;
            this.status.scrollIcon = 'show';
            TweenMax.to(this.$scrollIcon, .6 ,{
                opacity:1,
                y: 0,
                display: 'block',
                ease: Power2.easeOut,
            });
            TweenMax.to(this.$headerNavi, .6 ,{
                opacity:1,
                ease: Power2.easeOut,
            });
        }
    }

    resize (w,h) {

        if(this.status.exResizeMode) return;

        this.w = w;
        this.h = h;

        this.bodyHeight = this.$body.getBoundingClientRect().height;

        if(this.inertia){
            TweenMax.set(this.$root,{"height":this.bodyHeight});
        }

        this.pararax.resize(this.h);
        this.contents.resize(this.h);

    }
    exResize(off,h){//他のjsから指定した高さに変更させる

        if(off){
            this.status.exResizeMode = false;
            TweenMax.set(this.$root,{"height":h});
            TweenMax.set(this.$root,{"position":"","top":"","left":""});
            this.changeMode("normal",false);
        }else{
            this.status.exResizeMode = true;
            this.status.exResizeModeDelay = true;
            this.changeMode("select",false);
            TweenMax.set(this.$root,{"height":h});
            TweenMax.set(this.$root,{"position":"fixed","top":0,"left":0});
            setTimeout(()=>{
                this.status.exResizeModeDelay = false;
            },1e3);

        }

    }

    /* -------------------------------------------

      -- Callback

    ------------------------------------------- */

    onComplete(){ /* スクロール動作が終わったら */


        if(!this.status.comp) {
            this.$bodyTag[0].classList.remove("is-scrolling");
        }

        this.status.comp = this.status.mode=="normal"?true:false;
        this.status.pagetop = false;
        this.status.endPoint = this.status.parsent>=1 ? true : false;

    }

    /* -------------------------------------------

      -- ステータスいじいじするやつ

    ------------------------------------------- */

    datGUI(){

    }
}